/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
let visualSuccessFunc = null
let visualErrorFunc = null
let srAlertFunc = null

export function initialize({
  visualSuccessCallback = visualSuccessFunc,
  visualErrorCallback = visualErrorFunc,
  srAlertCallback = srAlertFunc,
}) {
  visualSuccessFunc = visualSuccessCallback
  visualErrorFunc = visualErrorCallback
  srAlertFunc = srAlertCallback
}

export function alert(message, isError = false) {
  if (isError) {
    visualErrorFunc(message)
  } else {
    visualSuccessFunc(message)
  }
}

export function srAlert(message) {
  srAlertFunc(message)
}
